
import React from "react";
import { Badge } from "@/components/ui/badge";

interface SwapRequestStatusBadgeProps {
  status: string;
}

const statusColors = {
  pending: "bg-yellow-100 text-yellow-800",
  accepted: "bg-green-100 text-green-800",
  approved: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  completed: "bg-blue-100 text-blue-800",
};

const SwapRequestStatusBadge: React.FC<SwapRequestStatusBadgeProps> = ({ status }) => {
  const statusClass = statusColors[status as keyof typeof statusColors] || statusColors.pending;
  
  return (
    <Badge className={statusClass + " capitalize"}>
      {status}
    </Badge>
  );
};

export default SwapRequestStatusBadge;
